import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

function Privacy() {
  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <Card>
        <CardHeader>
          <CardTitle className="text-center text-2xl">Privacy Policy</CardTitle>
        </CardHeader>
        <CardContent className="prose dark:prose-invert max-w-none">
          <p>
            This application does not collect, store, or process any personal data beyond what is
            required for basic functionality. We do not use your data for marketing purposes or 
            share it with third parties.
          </p>
          <p>
            Any data collected is solely for the purpose of providing the core features of this
            application and is handled in accordance with best practices for data security.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

export default Privacy; 